<div class="label" *ngIf="templateOptions.label">
  <div class="text">{{ templateOptions.label | t }}</div>
  <div
    class="status"
    *ngIf="templateOptions.displayGroupStatus"
    [class.valid]="!invalid()"
    [class.invalid]="invalid()"
  >
    <sn-icon *ngIf="invalid()">cancel</sn-icon>
    <sn-icon *ngIf="!invalid()">check_circle</sn-icon>
  </div>
  <div class="divider"></div>
</div>
<div [ngClass]="field.fieldGroupClassName">
  <ng-container #fieldComponent></ng-container>
</div>
